import {
  Box,
  createIcon,
  Icon,
  Text,
  useMediaQuery,
  VStack,
} from '@chakra-ui/react'
import { DyteSpinner } from '@dytesdk/react-ui-kit'
import { useEffect } from 'react'
import { BsCameraVideoFill } from 'react-icons/bs'
import { FaMicrophone } from 'react-icons/fa'

import { useLocale } from '../../../hooks/useLocale'
import { useMixpanel } from '../../../utils/MixpanelContext'

const Initializing = ({ eventId, roomName, micAccess, cameraAccess }: any) => {
  const mixpanel = useMixpanel()
  const { t } = useLocale()
  useEffect(() => {
    mixpanel.track('inapp_meeting_loading', {
      eventId,
      roomName,
    })
  }, [mixpanel, eventId, roomName])

  const isMobileScreen = useMediaQuery('(max-width: 640px)')[0]

  return (
    <div className="h-full w-full p-4 flex flex-col bg-black text-white overflow-hidden justify-center position-relative">
      {(!micAccess || !cameraAccess) && !isMobileScreen && (
        <>
          <div className="dotted-line"></div> {/* Dotted line */}
          <div className="big-arrow">
            <Arrow boxSize={50} color="white" viewBox="0 0 100 100" />{' '}
            {/* Big arrow */}
          </div>
        </>
      )}
      <VStack fontSize={'xl'} spacing={4}>
        <Box w="full" h="full" bg="black" borderRadius="md" p={4}>
          {(!micAccess || !cameraAccess) && (
            <>
              <Text fontSize="2xl" fontWeight="bold" ml={'150px'}>
                <Icon as={BsCameraVideoFill} /> {t('allow_access_camera_and')}{' '}
                <Icon as={FaMicrophone} /> {t('microphone_on_your_browser')}
              </Text>
            </>
          )}
        </Box>
        <Text>{t('initializing_meeting')}</Text>
        <DyteSpinner />
      </VStack>
    </div>
  )
}

const Arrow = createIcon({
  displayName: 'Arrow',
  viewBox: '0 0 100 100 ', // Adjusted for a larger display
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M50 10 L90 90 L50 70 L10 90 Z" // Modified to point upwards
      fill="currentColor"
    />
  ),
})

export default Initializing
